import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../inc/Header";
import Kanerdul from "../images/dul pages.jpg";
import Necklece from "../images/necklace pages new.jpg";
import Ring from "../images/ring-main.jpg";
import bala from "../images/BALA NEW.jpg";

// import Chikimage from "../images/chikimage.jpg";
import Locket from "../images/locket page main.jpg";
import Churpage from "../images/chur gold page main.jpg"

import Gold_Mantasa from "../images/mantasa page.jpg";
import glasschur from "../images/glass chur main.jpg";

import Stone from "../images/stone front.jpg";
import Astrologyberhampore from "../images/ajit_sastri page.jpg";
import SolidChuri from "../images/Solid Churi_home.jpg";
import Passa from "../images/Passa_gold.jpg"
import Pipehar from "../images/Pipehar.jpg";
import sankhapage from "../images/sankha main page.jpg"
import pola from "../images/pola main site show.jpg";

import Braceletloha from "../images/Bracelet Loha Main page.jpg";


import "./Silck.css";

import { Link } from 'react-router-dom';
import KhapNecklace from "../images/khap necklace.jpg"
import chatainecklace from "../images/chatai necklace.jpg";


function Silck() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  return (
    <div>
      <Header />

      <div className="animat">
        <Slider {...settings}>
          <div>

            <div className="card mb-4 border-White box ">
              <Link to="/pola">
                <img src={pola} className="card-img-top" alt="pola" />

                <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Pola<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></p>
              </Link>
            </div>

          </div>
          <div>

            <div className="card mb-4 border-White box ">
              <Link to="/sankha">
                <img src={sankhapage} className="card-img-top" alt="sankhapage" />

                <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Sankha <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></p>
              </Link>
            </div>

          </div>
          <div>

            <div className="card mb-4 border-White box ">
              <Link to="/chur">
                <img src={Churpage} className="card-img-top" alt="Churpage" />

                <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Chur <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></p>
              </Link>
            </div>

          </div>
          <div className="card mb-4 border-White box">
            <a href='mantasa'>
              <img src={Gold_Mantasa} className="card-img-top" alt="Mbdharandsonjewellers_mantasa" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text fonts mb-0"><small> Mantasa <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></small></p>
            </a>

          </div>
          <div className="card mb-4 border-White box ">
            <Link to="/Locketpage">
              <img src={Locket} className="card-img-top" alt="Locket" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Locket <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></p>
            </Link>
          </div>
             <div className="card mb-4 border-White box ">
            <Link to="/bala">
              <img src={bala} className="card-img-top" alt="Bala"/>

              <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Bala <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></p>
            </Link>
          </div>
          <div className="card mb-4 border-White box ">
            <Link to="/Pipehar">
              <img src={Pipehar} className="card-img-top" alt="Pipehar" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text fonts mb-0">Pipe har <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></p>
            </Link>
          </div>
          <div className="card mb-4 border-White box ">
            <Link to="/passa">
              <img src={Passa} className="card-img-top" alt="Passa" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Passa <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></p>
            </Link>
          </div>
          <div className="card mb-4 border-White box ">
            <Link to="/solidchuri">
              <img src={SolidChuri} className="card-img-top" alt="Solid Churi" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text font mb-0"> <small>Solid Churi<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></small></p>
            </Link>
          </div>
          <div>




            <div className="card mb-4 border-White box">
              <Link to="/BraceletLoha">
                <img src={Braceletloha} className="card-img-top mb-0" alt="Bracelet Loha"/>

                <p style={{ color: "maroon", padding: "8px" }} className="card-text font mb-0"><small>Bracelet Loha <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></small></p>
              </Link>
            </div>
          </div>
           <div>

            <div className="card mb-4 border-White box">
              <Link to="/stone">
                <img src={Stone} className="card-img-top mb-0" alt="Stoneberhampore" />

                <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Stone <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></p>
              </Link>
            </div>
          </div>
          <div>
            <div className="card mb-4 border-White box ">
              <a href="Astro">
                <img src={Astrologyberhampore} className="card-img-top" alt="Astrologyberhampore" />

                <div className='fonts'>
                  <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0"><small>Astrology <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                  </svg></small></p>
                </div>
              </a>
            </div>

          </div>







          <div>
            <div className="card mb-4 border-White box ">
              <Link to="/dul">
                <img src={Kanerdul} className="card-img-top" alt="Kanerdul" />


                <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Dul <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></p>
              </Link>

            </div>
          </div>



          <div>
            <div className="card mb-4 border-White box ">
              <Link to="/necklace-page">
                <img src={Necklece} className="card-img-top" alt="Nacklece" />

                <p style={{ color: "maroon", padding: "8px" }} className="card-text fonts mb-0"><small>Necklace <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></small></p>
              </Link>
            </div>
          </div>


          {/* <div className="card mb-4 border-White box ">
            <Link to="/chik">
              <img src={Chikimage} className="card-img-top" alt="Chikimage" />
            </Link>
            <div className="card-body">

              <p style={{ color: "maroon" }} className="card-text mb-0">Chik</p>
              <Link to="/chik">
                <p className="card-text"> <small> <span>Explore<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                </svg></span></small></p> </Link>
            </div>
          </div> */}











          <div className="card mb-4 border-White box">
            <a href='churpage'>
              <img src={glasschur} className="card-img-top" alt="glasschur" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text font mb-0"> <small>Glass Chur <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></small></p>
            </a>

          </div>


          <div className="card mb-4 border-White box">
            <a href='KhapNecklace'>
              <img src={KhapNecklace} className="card-img-top" alt="KhapNecklace" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text font mb-0"> <small>Khap Necklace <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></small></p>
            </a>

          </div>

          <div className="card mb-4 border-White box">
            <a href='chatai-necklace'>
              <img src={chatainecklace} className="card-img-top" alt="chatainecklace" />

              <p style={{ color: "maroon", padding: "8px" }} className="card-text font mb-0"> <small>Chatai Necklace <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
              </svg></small></p>
            </a>

          </div>
          <div>
            <div className="card mb-4 border-White box ">
              <Link to="/ring">
                <img src={Ring} className="card-img-top" alt="Ring" />

                <p style={{ color: "maroon", padding: "8px" }} className="card-text mb-0">Ring <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                </svg></p>
              </Link>
            </div>

          </div>



        </Slider>
      </div>

    </div>
  )
}



export default Silck
